import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=76d4d9fd&scoped=true"
import script from "./AppMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d4d9fd",
  null
  
)

export default component.exports